<template>
  <div class="pass-expired-wrapper">
    <hr class="h-2 custom-shadow" />
    <div class="w-full px-5">
      <div class="my-4" v-if="!changePasswordSuccess">
        <zt-alert :text="alertMessage" :color="errorPassword ? 'danger' : 'primary'" :closeIcon="false">
          <div slot="icon">
            <div class="rounded-full w-24 h-24 flex justify-center items-center border-2 border-zt-primary-200" :class="{
              'border-zt-danger': errorPassword,
              'bg-zt-danger': errorPassword
            }">
              <zt-icon v-if="errorPassword" class="text-5xl ml-px text-zt-white" name="shield-asterisk" />
              <zt-icon v-else class="text-5xl mb-1" name="exclamation-triangle" />
            </div>
          </div>
        </zt-alert>
      </div>
    </div>
    <ValidationObserver v-slot="{ invalid }">
      <div class="w-full px-5">
        <div v-if="changePasswordSuccess">
          <ZTModalPasswordExpiredSuccess />
        </div>
        <div v-else class="mx-auto py-3">
          <ZTModalPasswordExpiredFields v-model="passExpiredFields" :password-policies="passPolicies" />
        </div>
      </div>
      <div class="py-3 px-4 flex justify-end items-center buttons-wrapper">
        <div v-if="!changePasswordSuccess">
          <span @click="$emit('goto-switch-company')" class="mr-5 cursor-pointer">{{
            $t('message.loginComponent.passwordExpired.go_back_btn')
            }}</span>
          <zt-button :disabled="invalid" class="py-3 px-4" @click="changePasswordExpired">{{
            $t('message.loginComponent.passwordExpired.update_pass_btn')
            }}</zt-button>
        </div>
        <div v-else>
          <zt-button @click="$emit('goto-dashboard')" class="py-3 px-4">{{
            $t('message.loginComponent.passwordExpired.go_to_dashboard')
          }}</zt-button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import ZTModalPasswordExpiredFields from '@/components/passwordExpired/modalPasswordExpiredFields.vue'
import ZTModalPasswordExpiredSuccess from '@/components/passwordExpired/modalPasswordExpiredSuccess.vue'
import Company from '@/apiClient/Company.js'
import Users from '@/apiClient/Users.js'

export default {
  name: 'PasswordExpiredModal',
  components: {
    ZTModalPasswordExpiredFields,
    ZTModalPasswordExpiredSuccess
  },
  data() {
    return {
      company: '',
      users: '',
      passPolicies: {},
      passExpiredFields: {
        password: '',
        rePassword: ''
      },
      errorPassword: false,
      errorCode: '',
      changePasswordSuccess: false
    }
  },
  methods: {
    async changePasswordExpired() {
      this.errorPassword = false
      this.errorCode = ''
      let oldPass = null
      await this.users
        .changePassV2(
          oldPass,
          this.passExpiredFields.password,
          this.passExpiredFields.rePassword
        )
        .then(response => {
          if (response.status === 200) {
            this.changePasswordSuccess = true
          }
        })
        .catch(error => {
          this.errorPassword = true
          this.errorCode = error.response.data.codes[0].code
        })
    },
    async getPasswordPolicies() {
      await this.company
        .passwordPolicies()
        .then(response => {
          this.passPolicies = response.data
        })
        .catch(error => { })
    }
  },
  computed: {
    alertMessage() {
      let msg = this.$t(
        'message.loginComponent.passwordExpired.pass_expired_message'
      )
      if (this.errorCode !== '') {
        msg = this.$t(
          `message.loginComponent.passwordExpired.message_error.error_${this.errorCode}`
        )
        if (!msg) {
          msg = `message.loginComponent.passwordExpired.message_error.no_handled_error`
        }
      }
      return msg
    },
  },
  created() {
    this.company = new Company()
    this.users = new Users()
    this.getPasswordPolicies()
  }
}
</script>

<style lang="scss" scoped>
.pass-expired-wrapper {

  // width: 430px;
  .buttons-wrapper {
    background-color: #eeeeee;
  }
}
</style>
